/**
 * Zipcode Service
 *
 * @memberof SubscriptionRegistrationComponent
 */
import {Injectable} from '@angular/core';


@Injectable()
export class ZipcodeService {
    // --------------------------------------------------------------------------
    /**
     * UI Validation for zipcode.
     */
    // --------------------------------------------------------------------------
    public validateZipcode(zipCode: string): any {
        const returnObj = {'validZipcode': false, 'message': ''};
        if (zipCode !== undefined && zipCode.length <= 0 || zipCode === undefined) {
            returnObj.message = 'ZIP Code is required.';
        } else if (zipCode.match(/\D/g) != null) {
            returnObj.message = 'ZIP Code must contain numeric characters only.';
        } else if (zipCode.length < 5) {
            returnObj.message = 'Please enter 5 numbers or more.';
        } else {
            returnObj.validZipcode = true;
        }
        return returnObj;
    }
}// End ZipcodeService
